import React from "react";


import DeleteAccountModal from "./DeleteAccountModal";

function DeleteAccount() {
  return (
    <div className="delete-profile">
        <p>Delete your account</p>
        <p>Once you delete your account, there is no going back. Please be certain.</p>
        <DeleteAccountModal/>
    </div>
  );
}

export default DeleteAccount;
